// extracted by mini-css-extract-plugin
export default {"consent":"CookieModal_consent__5CmX4","consentGrid":"CookieModal_consentGrid__w+-Oj","buttonGrid":"CookieModal_buttonGrid__iboxV","consentModal":"CookieModal_consentModal__yD0wB"};